import { mapRecordsFromServer } from 'coreOld/mappers';
import { partfinitiClient } from 'coreOld/services';
import { GetManyResponse, IRequestPayload } from 'coreOld/types';
import { getQueryString } from 'coreOld/utils';
import { IManufacturer } from 'partsOld/types';

export const getMany = async (
  requestPayload: IRequestPayload,
  signal?: AbortSignal
): Promise<GetManyResponse<IManufacturer>> => {
  const { data } = await partfinitiClient.get(
    `/manufacturers/index/autocomplete?${getQueryString(requestPayload)}`,
    signal
  );

  return mapRecordsFromServer<IManufacturer>(data.manufacturers, data.total_count);
};
